import React from 'react';
import { ButtonProps } from 'fronton-react/button/types';
import { StyledButton } from './styles';

type Props = ButtonProps & { to?: string };

export const CarouselItem: React.FC<Props> = ({ children, ...props }) => (
  <StyledButton buttonSize="l" {...props}>
    {children}
  </StyledButton>
);
